<app-header [showBack]="true"></app-header>
<app-set-meta title="企業発信コンテンツ掲載基準｜Forbes CAREER"></app-set-meta>

  <!-- <app-tab-menu></app-tab-menu> -->
  	<div class="term-body">
  		<h1>企業発信コンテンツ掲載基準
		</h1>
	    <div>
	        <ol>
				<li>Forbes CAREER 企業発信コンテンツ掲載基準（以下「本掲載基準」といいます）は、当社が提供するすべてのコンテンツ配信機能に適用される基準です。</li>
				<li>本サービスの利用企業（以下「利用企業」といいます）は、配信するコンテンツについて、この基準を遵守する必要があります。</li>
				<li>当社は、本掲載基準に基づきコンテンツの掲載の可否を総合的に判断しています。当社の判断はコンテンツに関する利用企業の責任を軽減するものではありません。コンテンツ掲載の申し込みを行った利用企業は、コンテンツに関する責任は利用企業自身が負うことを承諾したものとします。</li>
				<li>当社は、すでに配信したコンテンツについて、本掲載基準に違反する等の事由により第三者から損害の賠償を請求された場合には、利用企業に対し当該損害の賠償を請求することができるものとします。</li>
				<li>コンテンツの掲載可否を判断した理由の回答はいたしかねます。</li>
				<li>本掲載基準に基づき、コンテンツの修正をお願いする場合や、事前の断りなく配信内容のお取り下げまたは一部表現の修正をさせていただくことがございます。</li>
				<li>配信の内容によっては、本サービスの利用停止を検討させていただく場合がございます。</li>
				<li>本掲載基準は、法改正や社会的状況を考慮し、事前の断りなく変更する場合がございます。</li>
	        </ol>
		</div>
		<h4>【配信いただけない内容】</h4>
		<div>
			<ul>
				<li>コンテンツを発信する企業と発信内容との関係性が不明である内容</li>
				<li>新規公開情報を含まない内容</li>
				<li>過去に配信した情報を、集客・誘導目的のために再度告知するような内容</li>
				<li>虚偽、詐欺的行為、誇大表現を含む内容</li>
				<li>比較表現を用いた内容、特定の個人団体を誹謗中傷する表現を含む内容</li>
				<li>投機心を著しく煽る表現を含む内容</li>
				<li>宗教の勧誘に関わる表現を含む内容</li>
				<li>公序良俗に反する表現を含む内容</li>
				<li>アダルト商品、風俗店、風俗店情報など、成人向けの表現を含む内容 </li>
				<li>残虐的、猟奇的、猥褻的、また嫌悪感や不快感を与える表現を含む内容 </li>
				<li>法律で禁止されている行為を連想させる表現、関係諸法規を遵守しない表現を含む内容  </li>
				<li>外部URLへのリンクが複数設定されており、情報量が過多である内容</li>
				<li>犯罪に使用されるおそれがある内容</li>
				<li>医療または医療技術・に関しては、日本国内で判断できる医療技術水準でない内容</li>
				<li>開運・魔よけ・加持祈祷・迷信など、非科学的で人心を惑わすおそれがある内容</li>
				<li>商品やサービスなどの訴求が中心テーマのもの、客観性に乏しいもの、適時性のない内容</li>
				<li>最大級またはその類の表記をする場合に、データ出典元や根拠の記載がない内容</li>
				<li>第三者の肖像権や著作権などの権利を侵害する表現を含む内容 </li>
				<li>第三者の名誉・信用・プライバシー・肖像権等の人格的権利を侵害する内容</li>
			</ul>
		</div>
		<div class="credit">
			以上<br>
			2020年10月29日 制定
		</div>
	</div>
  <app-footer></app-footer>

<!-- /.wrapper -->